import { faDice, faPlus, faTimes, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { GameLogicBlock } from "../../types/LogicTypes";
import { CharacterStat } from "../../types";
import { strToCharacterStat } from "../3D/helpers/uiHelpers";

interface EditBlockModalProps {
    block: GameLogicBlock | undefined,
    selectedBlockId: string,
    setSelectedBlockId: Dispatch<SetStateAction<string>>,
    apply: (block: Partial<GameLogicBlock>) => void,
}
const EditBlockModal: React.FC<EditBlockModalProps> = (props) => {
    const block = props.block
    const [ openDialogue, setOpenDialogue ] = useState<string | undefined>()
    const [ message, setMessage ] = useState<string | undefined>()
    const [ run, setRun ] = useState<string | undefined>()
    const [ type, setType ] = useState<string | undefined>()
    const [ testActionStat, setTestActionStat ] = useState<CharacterStat | undefined>()
    const [ testActionStatMod, setTestActionStatMod ] = useState<string | undefined>()
    // const [ testActionStatReq, setTestActionStatReq ] = useState<string | undefined>()
    // const [ condition, setCondition ] = useState<string | undefined>()
    const [ addCmdModalOpen, setAddCmdModalOpen ] = useState<boolean>(false)

    useEffect(() => {
        setOpenDialogue(block?.openDialogue)
        setMessage(block?.message)
        setRun(block?.run)
        setType(block?.type)
        setTestActionStat(block?.testAction?.stat)
        setTestActionStatMod(block?.testAction?.statMod ? `${block?.testAction?.statMod}` : undefined)
    }, [block]);

    const close = () => {
        props.setSelectedBlockId("")
    }

    const onMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setMessage(e.currentTarget.value)
    }
    const onRunChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRun(e.currentTarget.value)
    }

    // APPLY: Add all modifyable things here
    const apply = () => {
        props.apply(
            {
                openDialogue,
                message,
                run,
                type,
                testAction: testActionStat ? {
                    stat: testActionStat ?? "inf",
                    statMod: testActionStatMod ? parseInt(testActionStatMod) : undefined,
                    // req: testActionStatReq,
                    fail: [],
                    pass: [],
                } : undefined
            }
        )
    }

    const addCmd = (cmd: string) => {
        const runArray = (run !== "" && run !== undefined) ? run.split(",") : []
        runArray.push(`>${cmd.replace(">", "")}`)

        // Make sure "end" is always last
        const end = runArray.indexOf(">end")
        if (end > -1) {
            runArray.splice(end, 1)
            runArray.push(">end")
        }

        setRun(runArray.length > 0 ? runArray.join(",") : "")
        setAddCmdModalOpen(false)
    }

    const removeCmd = (i: number) => {
        const runArray = (run !== "" && run !== undefined) ? run.split(",") : []
        // runArray.push(`>${cmd.replace(">", "")}`)
        runArray.splice(i, 1);
        setRun(runArray.length > 0 ? runArray.join(",") : "")
    }

    return (
        <>
            <Modal show={props.selectedBlockId !== ""} onHide={close} size={"lg"}>
                <div className="modal-content story-edit-modal" style={{backgroundImage: "url(img/ui/bg_noise.png)"}}>
                    <Modal.Header className="p-1">
                        <Modal.Title>
                            Edit Block
                            <div className="modal-subtitle">Yeah</div>
                        </Modal.Title>
                        <div className="close-button"><FontAwesomeIcon icon={faTimes} className="clickable p-3" onClick={close} /></div>
                    </Modal.Header>
                    <Modal.Body>
                        {(block?.openDialogue) &&
                            <div className="mb-2">
                                <span className="modal-subtitle">Dialogue Title</span>
                                <input className="w-100" value={openDialogue} onChange={(e) => { setOpenDialogue(e.target.value) }} />
                            </div>
                        }
                        {(block?.type) &&
                            <div className="mb-2">
                                <span className="modal-subtitle">Type</span>
                                <input className="w-100" value={type} onChange={(e) => { setType(e.target.value) }} />
                            </div>
                        }
                        {(!block?.testAction || block?.message !== undefined) &&
                            <div className="mb-2">
                                <span className="modal-subtitle">Message</span>
                                <textarea value={message} onChange={(e) => { onMessageChange(e) }} />
                            </div>
                        }
                        {block?.testAction &&
                            <div className="mb-2">
                                <span>
                                    <FontAwesomeIcon icon={faDice} /> Test
                                    {/* <input value={block.testAction.stat} /> */}
                                    <select value={testActionStat} onChange={(e) => { setTestActionStat(strToCharacterStat(e.target.value)) }} className="mx-2">
                                        <option value="inf">Influence</option>
                                        <option value="lore">Lore</option>
                                        <option value="obs">Observation</option>
                                        <option value="str">Strength</option>
                                        <option value="will">Willpower</option>
                                    </select>
                                    +
                                    <input type="text" value={testActionStatMod ?? ""} onChange={(e) => { setTestActionStatMod(e.target.value) }} style={{width: "50px"}} className="mx-2" />
                                    {/* Requires */}
                                    {/* <input type="text" value={block.testAction.req} style={{width: "50px"}} className="mx-2" /> */}
                                </span>
                            </div>
                        }
                        <div>
                            <span className="modal-subtitle">Run</span>
                            <div className="mb-1">
                                {run?.split(",").map((cmd, i) => <Cmd cmd={cmd} removeCmd={() => removeCmd(i)} />)}
                                <span key={"add"} className="cmd clickable" onClick={() => { setAddCmdModalOpen(true) }}><FontAwesomeIcon icon={faPlus} /></span>
                            </div>
                            <input disabled className="w-100" value={run} onChange={(e) => { onRunChange(e) }} />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-theme-white-noborder" style={{backgroundImage: "url(img/ui/btn_02.png)"}} onClick={apply}>Apply</button>
                    </Modal.Footer>
                </div>
            </Modal>

            <AddCmdModal
                isOpen={addCmdModalOpen}
                close={() => { setAddCmdModalOpen(false) }}
                addCmd={addCmd}
            />
        </>
    )
}

interface CmdProps {
    cmd: string
    removeCmd: () => void
}
const Cmd: React.FC<CmdProps> = (props) => {
    const cmd = props.cmd.replace(">", "")
    let canEdit = true
    if (cmd === "end") canEdit = false
    if (cmd.startsWith("removeData:dialogue")) canEdit = false
    if (cmd.startsWith("addData:dialogue")) canEdit = false

    return (
        <span className="cmd" style={{opacity: canEdit ? 1 : .6}}>
            {cmd}
            {canEdit && <FontAwesomeIcon icon={faTrashAlt} className="ms-2 clickable" onClick={props.removeCmd} />}
        </span>
    )
}

interface AddCmdModalProps {
    isOpen: boolean
    close: () => void
    addCmd: (cmd: string) => void
}
const AddCmdModal: React.FC<AddCmdModalProps> = (props) => {
    const [ cmd, setCmd ] = useState<string>("")

    useEffect(() => {
        setCmd("")
    }, [props.isOpen]);

    const cmdChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCmd(e.currentTarget.value)
    }

    const addCmd = () => {
        props.addCmd(cmd)
    }

    const presets = [
        {
            title: "Clues",
            presets: [
                { label: "Gain THIS Clue", cmd: "gainClue" },
                { label: "Gain A Clue", cmd: "addItem:clue" },
                { label: "Discard Clue", cmd: "discardClue" },
                { label: "Lose Clue", cmd: "removeItem:clue" },
                { label: "Spawn Clue", cmd: "spawn:clue" },
            ]
        },
        {
            title: "Add Conditions",
            presets: [
                { label: "amnesia", cmd: "addCondition:amnesia" },
                { label: "back injury", cmd: "addCondition:back_injury" },
                { label: "blight", cmd: "addCondition:blight" },
                { label: "blessed", cmd: "addCondition:blessed" },
                { label: "cursed", cmd: "addCondition:cursed" },
                { label: "debt", cmd: "addCondition:debt" },
                { label: "delayed", cmd: "addCondition:delayed" },
                { label: "detained", cmd: "addCondition:detained" },
                { label: "hallucinations", cmd: "addCondition:hallucinations" },
                { label: "head_injury", cmd: "addCondition:head_injury" },
                { label: "hypothermia", cmd: "addCondition:hypothermia" },
                { label: "infection", cmd: "addCondition:infection" },
                { label: "internal_injury", cmd: "addCondition:internal_injury" },
                { label: "leg_injury", cmd: "addCondition:leg_injury" },
                { label: "lost_in_time_and_space", cmd: "addCondition:lost_in_time_and_space" },
                { label: "paranoia", cmd: "addCondition:paranoia" },
                { label: "poisoned", cmd: "addCondition:poisoned" },
                { label: "wanted", cmd: "addCondition:wanted" },
            ]
        },
        {
            title: "Character Stats",
            presets: [
                { label: "Health", cmd: "addHealth:-1" },
                { label: "Sanity", cmd: "addSanity:-1" },
                { label: "Exp", cmd: "addExp:100" },
            ]
        },
        {
            title: "Improve Stats",
            presets: [
                { label: "Inf", cmd: "addCondition:improve_inf" },
                { label: "Lore", cmd: "addCondition:improve_lore" },
                { label: "Obs", cmd: "addCondition:improve_obs" },
                { label: "Str", cmd: "addCondition:improve_str" },
                { label: "Will", cmd: "addCondition:improve_will" },
            ]
        },
        {
            title: "Impair Stats",
            presets: [
                { label: "Inf", cmd: "addCondition:impair_inf" },
                { label: "Lore", cmd: "addCondition:impair_lore" },
                { label: "Obs", cmd: "addCondition:impair_obs" },
                { label: "Str", cmd: "addCondition:impair_str" },
                { label: "Will", cmd: "addCondition:impair_will" },
            ]
        },
        {
            title: "World Events",
            presets: [
                { label: "Advance Doom", cmd: "advanceDoom" },
                { label: "Solve Mystery", cmd: "advanceMystery" },
                { label: "Clock Ticks", cmd: "clockTicks:60" },
            ]
        },
        {
            title: "Other World",
            presets: [
                { label: "Close this Gate", cmd: "closeGate" },
                { label: "A Gate opens", cmd: "spawn:gate" },
            ]
        },
        {
            title: "Monster Ambush",
            presets: [
                { label: "Cultist", cmd: "monsterAmbush:monsters.cultist" },
                { label: "(random)", cmd: "monsterAmbush" },
            ]
        },
    ]

    return (
        <Modal show={props.isOpen} onHide={props.close}>
            <div className="modal-content story-edit-modal" style={{backgroundImage: "url(img/ui/bg_noise.png)"}}>
            <Modal.Header className="p-1">
                <Modal.Title>
                    Add Command
                    <div className="modal-subtitle"></div>
                </Modal.Title>
                <div className="close-button"><FontAwesomeIcon icon={faTimes} className="clickable p-3" onClick={props.close}/></div>
            </Modal.Header>
            <Modal.Body>
                <input className="w-100" value={cmd} onChange={cmdChanged} />
                <div className="mt-3">
                    {
                        presets.map((p1, i) => { return (
                            <div key={i}><span className="modal-subtitle">{p1.title}</span><br />
                                {p1.presets.map((p2, i) => { return <><span className="clickable outlined px-2" onClick={() => {setCmd(p2.cmd)}}>{p2.label}</span> </>})}
                            </div>
                        )})
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-theme-white-noborder" style={{backgroundImage: "url(img/ui/btn_02.png)"}} onClick={addCmd}>Apply</button>
            </Modal.Footer>
            </div>
        </Modal>
    )
}


export default EditBlockModal